import React, { useState } from 'react'
import { ReactComponent as ChevronDown } from '../../../assets/media/icons/chevron-down.svg'
import styles from './FiltersCategory.module.scss'
import PropTypes from 'prop-types'

const FiltersCategory = ({ selectedFilters, onFilterSelect, category, filters, preOpen }) => {
    const [isOpen, setIsOpen] = useState(preOpen || false)
    const contentId = `filter-content-${category.replace(/\s+/g, '-').toLowerCase()}`

    const handleToggle = () => {
        setIsOpen(!isOpen)
    }

    const handleKeyDown = e => {
        // Allow Enter or Space to toggle accordion
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault()
            handleToggle()
        }
    }

    return (
        <div className={`${styles.category} ${isOpen ? styles.open : ''}`}>
            <button
                className={styles.category_header}
                onClick={handleToggle}
                onKeyDown={handleKeyDown}
                aria-expanded={isOpen}
                aria-controls={contentId}
                type='button'
            >
                <h6 className={styles.category_heading}>{category}</h6>
                <ChevronDown className={`${styles.category_icon} ${isOpen ? styles.open : ''}`} aria-hidden='true' />
            </button>
{filters?.length > 0 && (
                <div
                    id={contentId}
                    className={`${styles.category_filter} ${isOpen ? styles.open : ''}`}
                    role='region'
                    aria-labelledby={contentId}
                    aria-hidden={!isOpen}
                    inert={!isOpen ? '' : undefined}
                >
                    <div className={`${styles.category_filterItem} ${styles.noPadding}`}></div>
                    {filters?.map((f, index) => {
                        const checkboxId = f.value || `${category}-${index}`
                        return (
                            <div key={f.value || index} className={styles.category_filterItem}>
                                <input
                                    type='checkbox'
                                    className={styles.category_filterItem_checkbox}
                                    name={category}
                                    id={checkboxId}
                                    value={f.value}
                                    checked={selectedFilters?.some(currentFilter => currentFilter.value === f.value)}
                                    onChange={() => onFilterSelect(f)}
                                    tabIndex={isOpen ? 0 : -1}
                                />
                                <label htmlFor={checkboxId}>{f.groupName || f.displayName || f.title}</label>
                            </div>
                        )
                    })}
                </div>
            )}
        </div>
    )
}

FiltersCategory.propTypes = {
    category: PropTypes.string,
    filters: PropTypes.array,
    selectedFilters: PropTypes.array,
    onFilterSelect: PropTypes.func,
    preOpen: PropTypes.bool,
}

export default FiltersCategory
